"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInShellSelector = exports.isNotInShell = exports.isInShell = void 0;
var isInShell = top !== self; // eslint-disable-line no-restricted-globals

exports.isInShell = isInShell;
var isNotInShell = !isInShell;
exports.isNotInShell = isNotInShell;

var isInShellSelector = function isInShellSelector() {
  return isInShell;
};

exports.isInShellSelector = isInShellSelector;